module.exports = __webpack_public_path__ + "images/poster/type_A_85970d6ca57bcce9886d691cda0d69ff.jpg";